import {type} from 'arktype'
import {countries, type TCountryCode} from 'countries-list'
import getSymbolFromCurrency from 'currency-symbol-map'

export const COUNTRY_CODES = Object.keys(countries) as TCountryCode[]

// United states, Great Britain, Australia, and Canada
export const SUPPORTED_COUNTRIES = ['US', 'GB', 'AU', 'CA'] as const satisfies TCountryCode[]
export const SupportedCountries = type.enumerated(...SUPPORTED_COUNTRIES)
export type SupportedCountries = typeof SupportedCountries.infer

export function isSupportedCountry(country: unknown): country is SupportedCountries {
  if (typeof country !== 'string') return false
  return SUPPORTED_COUNTRIES.includes(country)
}

export function isCountryCode(countryCode: unknown): countryCode is TCountryCode {
  if (typeof countryCode !== 'string') return false
  return COUNTRY_CODES.includes(countryCode)
}

export const countryAtom = atomWithStorage<SupportedCountries>('country', 'US')

export function useCountry() {
  return useAtom(countryAtom)
}

export function useSetCountry() {
  return useSetAtom(countryAtom)
}

export function getCurrency(countryCode: SupportedCountries) {
  const country = countries[countryCode]
  return country.currency[0]
}

export const currencyAtom = atom<string | undefined>(get => {
  const countryCode = get(countryAtom)
  return getCurrency(countryCode)
})

export function useCurrency() {
  return useAtom(currencyAtom)[0]
}

export const currencySymbolAtom = atom<string | undefined>(get => {
  const currency = get(currencyAtom)
  return currency ? getSymbolFromCurrency(currency) : undefined
})

export function useCurrencySymbol() {
  return useAtom(currencySymbolAtom)[0]
}
